import React, { Component, PropTypes } from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import cx from 'classnames';
import { displayCreation } from '../modals';

class AddManipButton extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      isLoading: false,
    };

    this._intervention = context.intervention;
    this._type = context.type;
    this._showCreate = this._showCreate.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  _showCreate(evt) {
    evt.preventDefault();

    const { zone } = this.props;

    this.setState({
      isLoading: true,
    });

    // Displaying creation modal
    displayCreation(
      this._intervention,
      this._type,
      zone.id,
      this.props.onAdded
    ).then(() => {
      this.setState({
        isLoading: false,
      });
    });
  }

  render() {
    const { isLoading } = this.state;

    const buttonClass = cx('ui floated right labeled icon button', {
      loading: isLoading,
    });

    return (
      <button className={buttonClass} onClick={this._showCreate}>
        <i className="icon add" />
        Ajouter un emplacement
      </button>
    );
  }
}

AddManipButton.propTypes = {
  zone: PropTypes.object.isRequired,
  onAdded: PropTypes.func.isRequired,
};

AddManipButton.contextTypes = {
  intervention: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

export default AddManipButton;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/components/AddManipButton.js